import React from "react";
import { Spinner } from "react-bootstrap";

const AuthLoading = () => {
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="text-center">
        <Spinner animation="border" variant="success" size="lg" />
        <p className="mt-3 text-muted">Checking authentication...</p>
      </div>
    </div>
  );
};

export default AuthLoading;
